import React from "react";
import { MainSurveyStore } from "modules/MainSurveyEditor/hooks/useMainSurvey";
import { useConditions } from "../hooks/useConditions";
import { ConditionsView } from "./ConditionsView";

export const Conditions = (props: ConditionsProps) => {
  const { isSubBlock, mainSurveyStore } = props;
  const {
    isSurveyBlockLoading,
    conditions,
    addCondition,
    deleteCondition,
    onUpdate,
    selectPath,
    setSelectPath,
    selectGoBackAction,
  } = useConditions(mainSurveyStore, isSubBlock);

  if (isSurveyBlockLoading) {
    return null;
  }

  return (
    <ConditionsView
      mainSurveyStore={mainSurveyStore}
      controller={{ conditions, addCondition, deleteCondition, onUpdate, selectPath, setSelectPath, selectGoBackAction }}
    />
  );
};

interface ConditionsProps {
  isSubBlock: boolean;
  mainSurveyStore: MainSurveyStore;
}
